import { render, staticRenderFns } from "./UiMap.vue?vue&type=template&id=a0367142"
import script from "./UiMap.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiMap.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports